import React, { Fragment, memo, Suspense } from "react";
import LocalizedContentContext from "./components/LocalizedContentContext";
import MessagesInjector from "./components/MessagesInjector";
import useGetMessages from "./hooks/useGetMessages";
const SSRSuspenseReplace = typeof window === "undefined" ? ({ fallback, ...rest }) => /* @__PURE__ */ React.createElement(Fragment, {
  ...rest
}) : ({ fallback, ...rest }) => /* @__PURE__ */ React.createElement(Suspense, {
  fallback,
  ...rest
});
const LocalizedContentManager = ({ messages, children, id, locale }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MessagesInjector, {
    id,
    messages,
    locale
  }), /* @__PURE__ */ React.createElement(LocalizedContentContext.Provider, {
    value: messages.read()
  }, /* @__PURE__ */ React.createElement(React.Fragment, null, children)));
};
const LocalizedContentManagerWrapper = memo((props) => {
  const { locale, id, resources, children, loadingElement } = props;
  const messages = useGetMessages({ locale, id, resources });
  const element = /* @__PURE__ */ React.createElement(LocalizedContentManager, {
    messages,
    id,
    locale
  }, children);
  if (messages.hydrated) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, element);
  }
  return /* @__PURE__ */ React.createElement(SSRSuspenseReplace, {
    fallback: loadingElement
  }, element);
});
var LocalizedContentManager_default = LocalizedContentManagerWrapper;
export {
  LocalizedContentManager,
  LocalizedContentManagerWrapper,
  LocalizedContentManager_default as default
};
